import { FormControlLabel, Radio, styled } from '@mui/material';

type Props = {
  title: string;
  value: string | number;
  isDisabled?: boolean;
};

export const RadioButton = ({ title, value, isDisabled }: Props) => {
  return (
    <FormControlLabel
      disabled={isDisabled}
      value={value}
      control={<StyledRadio color="primary" />}
      label={title}
    />
  );
};

const StyledRadio = styled(Radio)(({ theme }) => ({
  '&.Mui-checked': {
    color: theme.palette.customColors.emerald,
  },
}));
